import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { SelectsSection } from "./CustomInputFileComponent.styled";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import NotificationManager from "react-notifications/lib/NotificationManager";
import { theme as themeConfig } from "../../themes/themes";

const CustomInputFileComponent = ({
  keyId,
  componentConfiguration,
  setQualificationAttachFile,
  idQuestion,
  typeQuestion,
  itsPreview = true,
}) => {
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [statusButtonUpload, setStatusButtonUpload] = useState(false);
  const [selectorName, setSelectorName] = useState("");

  useEffect(() => {
    setSelectorName("input-field-" + idQuestion);
  }, []);

  const handleClearInputFile = () => {
    setFile(null);
    setFileName("");
    setStatusButtonUpload(false);
    document.getElementById(selectorName).value = "";
  };

  const handleValidateFileRestrictions = (file) => {
    let clearInputFile = false;
    const target = file.target;
    if (target.files && target.files[0]) {
      const maxAllowedSize = 2 * 1024 * 1024;

      if (target.files[0].size > maxAllowedSize) {
        NotificationManager.warning("Maximum file size 2MB", "", 5000);
        clearInputFile = true;
      }
      if (!detectExtensionFile(file)) {
        NotificationManager.warning(
          "Invalid file type, only JPEG/PDF",
          "",
          5000
        );
        clearInputFile = true;
      }

      if (clearInputFile) {
        file.target.value = "";
        target.value = "";
        handleClearInputFile();
      } else {
        const attachment = target.files;
        attachment[0] && setFileName(attachment[0].name);
        if (attachment) {
          setFile(attachment);
          setStatusButtonUpload(true);
        }
        itsPreview &&
          setQualificationAttachFile(
            attachment[0].name,
            idQuestion,
            "",
            typeQuestion,
            file
          );
      }
    }
  };

  const detectExtensionFile = (file) => {
    const extensionFile = file.target.files[0]?.type;
    switch (extensionFile) {
      case "application/pdf":
        return true;
      case "image/jpeg":
        return true;
      default:
        return false;
    }
  };

  return (
    <SelectsSection>
      <form
        key={keyId}
        onClick={() => {
          if (file === null && !statusButtonUpload) {
            document.querySelector(`.${selectorName}`).click();
          }
        }}
      >
        <Button
          disabled={statusButtonUpload}
          size="small"
          style={{ textTransform: "none" }}
        >
          Upload file
        </Button>
        <input
          className={selectorName}
          id={selectorName}
          type="file"
          accept="image/jpeg,application/pdf"
          hidden
          onChange={(e) => handleValidateFileRestrictions(e)}
        />
        {file ? (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              backgroundColor: themeConfig.neutral.gray[800],
              borderRadius: "2px",
              padding: "2px 3px",
            }}
          >
            {fileName}
            <DeleteIcon
              fontSize="small"
              style={{
                cursor: "pointer",
                backgroundColor: "black",
                borderRadius: "50%",
                color: themeConfig.neutral.gray[800],
                marginLeft: "3px",
                fontSize: "15px",
                padding: "2px",
                maxHeight: "15px",
                maxWidth: "15px",
              }}
              onClick={() => handleClearInputFile()}
            ></DeleteIcon>
          </span>
        ) : (
          <span>Please upload a JPEG or PDF file no bigger than 2MB</span>
        )}
      </form>
    </SelectsSection>
  );
};

export default CustomInputFileComponent;
